import React from "react";
import { PreviewPage } from "./PreviewPage";

export const WebContentPreviewPage = () => (
  <PreviewPage localStorageKey="web-filtering" />
);
